<lib-map-element [baseLayerId]="baseLayerId" [tileLoader]="tileLoader"></lib-map-element>
<lib-map-tools></lib-map-tools>
<app-map-popup></app-map-popup>
<app-map-address-popup></app-map-address-popup>
